import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.labels = this.el.querySelector('.o-list_header_labels')
  }

  activateSection(e) {
    const taxo = e.target.getAttribute('data-taxo')
    const title = this.el.querySelector(`.o-list_header_label[data-taxo="${taxo}"]`)

    if (e.way === 'enter') {
      if (title) {
        title.classList.add('-active')
      }
    }
    else {
      if (title) {
        title.classList.remove('-active')
      }
    }

    if (this.labels.querySelector('.-active')) {
      this.labels.classList.add('-active')
    }
    else {
      this.labels.classList.remove('-active')
    }
  }
}
